import React from 'react';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

interface DescriptionFadeStrengthSelectorProps {
  value: number;
  onChange: (strength: number) => void;
}

/**
 * DescriptionFadeStrengthSelector - Controls the intensity of description fade effect
 */
const DescriptionFadeStrengthSelector: React.FC<DescriptionFadeStrengthSelectorProps> = ({
  value,
  onChange
}) => {
  const handleValueChange = (values: number[]) => {
    onChange(values[0]);
  };

  const getStrengthLabel = (strength: number) => {
    if (strength <= 0.3) return 'No Fade';
    if (strength <= 0.7) return 'Moderate Fade';
    if (strength <= 1.2) return 'Strong Fade';
    return 'Heavy Fade';
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Description Fade Strength</Label>
        <div className="text-xs text-gray-500">
          {getStrengthLabel(value)} ({Math.round(value * 100)}%)
        </div>
      </div>
      
      <div className="space-y-2">
        <Slider
          value={[value]}
          onValueChange={handleValueChange}
          min={0.0}
          max={2.0}
          step={0.1}
          className="w-full"
        />
        
        <div className="flex justify-between text-xs text-gray-400">
          <span>No Fade (0%)</span>
          <span>Normal (100%)</span>
          <span>Heavy (200%)</span>
        </div>
      </div>
      
      <div className="text-xs text-gray-500">
        Controls how much the description fades on hover (0% = no fade, 200% = heavy fade)
      </div>
    </div>
  );
};

export default DescriptionFadeStrengthSelector;